module.exports = __webpack_public_path__ + "media/bootstrap-icons/arrow-down-left-square-240e1db6.svg";